import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.tsx'
import './index.css'
import { GlobalErrorBoundary } from './components/GlobalErrorBoundary';
import { initSentry } from './lib/sentry';

initSentry();

// Apply persisted theme before first paint to avoid flash
const storedTheme = localStorage.getItem('swak-platform-theme');
if (storedTheme === 'light' || storedTheme === 'dark') {
    document.documentElement.dataset.theme = storedTheme;
}

// Debug: Check environment variables on startup
console.log('Platform App Startup Checks:');
console.log('- VITE_NEON_AUTH_URL configured:', !!import.meta.env.VITE_NEON_AUTH_URL);
if (!import.meta.env.VITE_NEON_AUTH_URL) {
    console.error('CRITICAL: VITE_NEON_AUTH_URL is missing. Auth will fail.');
}

ReactDOM.createRoot(document.getElementById('root')!).render(
    <React.StrictMode>
        <GlobalErrorBoundary>
            <App />
        </GlobalErrorBoundary>
    </React.StrictMode>,
)
